// extracted by css-extract-rspack-plugin
export default {"FlexSuiteSubNavSpacer":"FlexSuiteSubNav-module__FlexSuiteSubNavSpacer__BAMLg","twoRows":"FlexSuiteSubNav-module__twoRows__ekcCc"};